module.exports = __webpack_public_path__ + "img/main-content-mob.9f479127.jpg";